import DualButton from 'Components/Buttons/DualButton';
import { FilterSection } from 'Components/Filters';
import { ReactNode } from 'react';

export function TriStateFilter({
  value,
  buttonOne,
  buttonTwo,
  label,
  onChange,
  uuid,
}: {
  label: ReactNode;
  uuid: string;
  value?: boolean;
  onClear?: () => void;
  onChange: (v?: boolean) => void;
  buttonOne: ReactNode;
  buttonTwo: ReactNode;
}) {
  return (
    <FilterSection>
      <DualButton
        buttonOne={buttonOne}
        buttonTwo={buttonTwo}
        value={value}
        onChange={onChange}
      />
    </FilterSection>
  );
}
